'use strict';

//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************

//***********************************************************************************
//***********************************************************************************
//**** Abstract class for element types.
//***********************************************************************************
//***********************************************************************************

import { cn_element } from './cn_element';
import { cn_configuration } from './cn_configuration';
import { cn_element_type_visitor } from '../utils/visitors/cn_element_type_visitor';
import { cn_image_dir } from '../utils/image_dir';

export class cn_element_type extends cn_element {

    constructor(parent) {
        super(parent);
        this.class_name = 'cn_element_type';
        /**
         * @type {string}
         */
        this.name;

        /**
         * @type {string}
         */
        this.class_name = '';

        /** @type {boolean} */
        this.readonly = false;

        /** @type {any}  - Extra data (typically from CW). To be serialized  / deserialized as is. */
        this.extra_data = null;

        this.is_null = false;

        this.count = 0;
        
        /**
         * @type {string}
         */
        this.family= "";

    }

    //***********************************************************************************
    /**
     * Clone
     * @returns {cn_element_type}
     */
    clone() {
        return new cn_element_type();
    }

    //***********************************************************************************
    /**
     * returns displayable label (e.g. "mur générique 30cm")
     * @returns {string}
     */
    get_label() {
        return this.name;
    }

    //***********************************************************************************
    /**
     * Returns an array of objects describing the type.
     * @returns {{label: string, value?: any, decimals?: number, unit?: string}[]}
     */
    get_description() {
        return [];
    }

    //***********************************************************************************
    /**
     * returns displayable label for type (e.g. "type de mur")
     * @returns {string}
     */
    get_generic_label() {
        return '';
    }

    /**
     * Returns extra data for a given source
     * @param {string} source
     * @returns {any}
     */
    get_extra_data(source) {
        return (this.extra_data && this.extra_data[source]);
    }

    /**
     * Sets extra data for a given source.
     * @param {string} source
     * @param {any} data
     */
    set_extra_data(source, data) {
        if (data) {
            if (!this.extra_data)
                this.extra_data = {};
            this.extra_data[source] = data;
        }
        else if (this.extra_data && this.extra_data[source])
            this.extra_data[source] = data;
    }

    //***********************************************************************************
    /**
     * draw svg icon
     * @param {number} width
     * @param {number} height
     * @returns {string}
     */
    draw_svg_icon(width, height) {
        return `<image xlink:href="${cn_image_dir()}texture_.jpg" x="0" y="0" width="${width}" height="${height}" preserveAspectRatio="xMidYMid slice" />`;
    }

    get_url() {
        return cn_image_dir() + "texture_.jpg";
    }

    /**
     * Fill configuration. If input config is null, must return the configuration
     * @param {cn_configuration} config
     * @return {cn_configuration}
     */
    fill_configuration(config = null) {
        return new cn_configuration();
    }

    /**
     * Loads data from configuration and fills the element type
     * @param {cn_configuration} configuration
     * @param {boolean} actual_change
     * @returns {boolean} true on success
     */
    load_configuration(configuration, actual_change = false) {
        return false;
    }

    model_keys() {
        return [];
    }

    /**
     * Accept element visitor
     *
     * @param {cn_element_type_visitor} element_type_visitor
     */
    accept_visitor(element_type_visitor) {
        throw Error('Not implemented : accept_visitor');
        // To be implemented by subclasses
    }

    /**
     * Serializes a type buiding agnostically (for example, to put into user libraries)
     */
    serialize_building_agnostic() {
        // Serialize without ID (to avoid potential ID conflicts between buildings)
        const res = this.serialize();
        delete res.ID;
        return res;
    }
    
    //***********************************************************************************
    /**
     * TODO : derivate this in order to create default families
     * @returns {string}
     */
    get_family() {
        return this.family;
    }

    //***********************************************************************************
    /**
     * TODO : derivate this in order to return default families
     * @returns {string[]}
     */
    get_default_families() {
        return [];
    }

}

